exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer[data-v-7f9bb2e8] {\n  display: block !important;\n}", ""]);

// exports
